var CustomSelect = function(options) {
  var elem          = typeof options.elem === 'string' ?
                        document.getElementById(options.elem) : options.elem,
      mainClass     = 'js-Dropdown',
      titleClass    = 'js-Dropdown-title',
      listClass     = 'js-Dropdown-list',
      selectedClass = 'is-selected',
      openClass     = 'is-open',
      selectOptions = elem.querySelectorAll('option'),
      optionsLength = selectOptions.length;

  // creating the pseudo-select container
  var selectContainer = document.createElement('div');
  selectContainer.className = mainClass;

  if (elem.id) {
    selectContainer.id = 'custom-' + elem.id;
  }

  // creating the always visible main button
  var button = document.createElement('button');

  button.className = titleClass;
  button.textContent = selectOptions[0].textContent;
  let svg = "<svg width='18' height='10' viewBox='0 0 18 10' fill='none' xmlns='http://www.w3.org/2000/svg'>"
  let svg2 = "<path d='M0.500819 1.7172L8.47482 9.4902C8.61488 9.62672 8.80273 9.70312 8.99832 9.70312C9.19391 9.70312 9.38176 9.62672 9.52182 9.4902L17.4988 1.7172C17.5641 1.6536 17.616 1.57757 17.6515 1.49358C17.6869 1.4096 17.7052 1.31936 17.7052 1.2282C17.7052 1.13704 17.6869 1.0468 17.6515 0.962813C17.616 0.878826 17.5641 0.802793 17.4988 0.739198C17.3649 0.608364 17.1851 0.535118 16.9978 0.535118C16.8106 0.535118 16.6308 0.608364 16.4968 0.739198L8.99832 8.0487L1.50132 0.739199C1.36744 0.608814 1.18795 0.535851 1.00107 0.535851C0.81419 0.535851 0.634696 0.608814 0.500818 0.739199C0.435503 0.802793 0.38359 0.878827 0.348143 0.962813C0.312696 1.0468 0.294433 1.13704 0.294433 1.2282C0.294433 1.31936 0.312696 1.4096 0.348143 1.49358C0.38359 1.57757 0.435503 1.6536 0.500819 1.7172Z' fill='#231F20'/> "
  let svg3 = '</svg>'
  
  button.innerHTML += `<span class='js-select-arrow'>${svg}${svg2}${svg3}</span>`;
  button.setAttribute('id', 'listboxlabel');
  button.setAttribute('role', 'label');

  // creating the UL
  var ul = document.createElement('ul');
  ul.className = listClass;
  ul.setAttribute('role', 'listbox');
  ul.setAttribute('aria-labelledby', 'listboxlabel');
  ul.setAttribute('aria-activedescendant', 'listbox-1')

  for (var i = 0; i < optionsLength; i++) {
      var li = document.createElement('li');

      li.innerHTML = selectOptions[i].textContent
      li.setAttribute('role', 'option');
      let liId = 'listbox-' + i;
      li.setAttribute('id', liId);
      li.setAttribute('data-value', selectOptions[i].value);
      li.setAttribute('data-index', i);


      if (selectOptions[i].getAttribute('selected') !== null) {
          li.classList.add(selectedClass);
          button.textContent = selectOptions[i].getAttribute('data-value')
          closeT()
      }

      ul.appendChild(li);
  }


  // appending the button and the list
  selectContainer.appendChild(button);
  selectContainer.appendChild(ul);


  button.innerHTML = selectOptions[0].textContent;
  button.innerHTML += `<span class='js-select-arrow'>${svg}${svg2}${svg3}</span>`;
  for (var i = 0; i < optionsLength; i++) {
    if (selectOptions[i].getAttribute('selected') !== null) {
        button.innerHTML = selectOptions[i].textContent
          button.innerHTML += `<span class='js-select-arrow'>${svg}${svg2}${svg3}</span>`;

    }
  }


  selectContainer.addEventListener('click', onClick);

  // pseudo-select is ready - append it and hide the original
  elem.parentNode.insertBefore(selectContainer, elem);
  elem.style.display = 'none';

  /**
  * Closes the current select on any click outside of it.
  */
  document.addEventListener('click', function(e) {
      if (!selectContainer.contains(e.target)) closeT();
  });

  const listItems = document.querySelectorAll(".js-Dropdown-list li");
  if (document.querySelectorAll(".is-selected").length == 0)
  {
    listItems[0].classList.add('is-selected')
  }
  
  const listItemIds = [];
  listItems.forEach(item => listItemIds.push(item.getAttribute('data-index')));


  // KEY values
  const SPACEBAR_KEY_CODE = [0,32];
  const ENTER_KEY_CODE = 13;
  const DOWN_ARROW_KEY_CODE = 40;
  const UP_ARROW_KEY_CODE = 38;
  const ESCAPE_KEY_CODE = 27;

  selectContainer.addEventListener("keydown", e => {
      switch (e.keyCode) {
      case ENTER_KEY_CODE:
        return;

      case DOWN_ARROW_KEY_CODE:
        t=focusNextListItem(DOWN_ARROW_KEY_CODE);
        //if (t.tagName === 'LI') {
          changeOption(t)
        //}
        return;

      case UP_ARROW_KEY_CODE:
        t=focusNextListItem(UP_ARROW_KEY_CODE);
        if (t.tagName === 'LI') {
          changeOption(t)
        }
        return;

      case ESCAPE_KEY_CODE:
        closeT();
        return;

      default:
        return;
    }
  });


  //Handles the clicks on current select.
  function onClick(e) {
    if (e instanceof MouseEvent) {
        e.preventDefault();
      }
      var t = e.target; 

      if (t.className === titleClass) {
          // button.classList.add('btn-open')
          toggle();
      }

      if (t.tagName === 'LI') {
          changeOption(t);
          closeT();
      }
  }

  function changeOption(t) {
    selectContainer.querySelector('.' + titleClass).innerHTML = t.innerHTML + `<span class='js-select-arrow'>${svg}${svg2}${svg3}</span>`;
    elem.options.selectedIndex = t.getAttribute('data-index');
    //trigger 'change' event
    let evt = new CustomEvent('change');
    elem.dispatchEvent(evt);
    // highlight the selected
    let isActive = document.querySelector('.is-selected') != null;
    if( isActive ) {
      for (let i = 0; i < optionsLength ; i++) {
        ul.querySelectorAll('li')[i].classList.remove(selectedClass);
      }
    }
    t.classList.add(selectedClass);
    t.setAttribute('aria-selected', 'true');
  }

  function focusNextListItem(direction) {
    let nextListItemId 
    let insideLi
    let newT
    let currentActiveElementIndex
    let isSelected = document.querySelector('.is-selected') != null;
    if(isSelected){
      currentActiveElementIndex = document.querySelector('.is-selected').getAttribute('data-index');
    }
    else {
      currentActiveElementIndex = 0;
    }

    if (direction === DOWN_ARROW_KEY_CODE) {

      const currentActiveElementIsNotLastItem =
      currentActiveElementIndex < listItemIds.length;
        if (currentActiveElementIsNotLastItem) {
          nextListItemId = listItemIds[currentActiveElementIndex + 1];
          insideLi = 'li[data-index="'+ nextListItemId + '"]';
          newT = document.querySelector(insideLi);
          return newT;
        }
      else {
          newT = document.querySelector('li[data-index="0"]');
          return newT;
      }
    }
    else if (direction === UP_ARROW_KEY_CODE) {
      const currentActiveElementIsNotFirstItem =
            currentActiveElementIndex > 1;
      if (currentActiveElementIsNotFirstItem) {
        const nextListItemId = listItemIds[currentActiveElementIndex - 2];
          insideLi = 'li[data-index="'+ nextListItemId + '"]';
          newT = document.querySelector(insideLi);
          return newT;
      }
      else{
        insideLi = 'li[data-index="'+ listItemIds.length + '"]';
        newT = document.querySelector(insideLi);
        return newT;
      }
    }
  }

  //Toggles the open/close state of the select on title's clicks.
  function toggle() {

    selectContainer.querySelector('.js-select-arrow').classList.toggle('rotateArrow')
      ul.classList.toggle(openClass);

   
  }

  //Opens the select.
  function open() {
      ul.classList.add(openClass);

  }

  //Closes the select.
  function closeT() {
      ul.classList.remove(openClass);

  }

};

//console.log('checking: ', document.querySelector('select'))
//Just putting this check to avoid a JS error in the console
if ( document.querySelector('select') ) {
  var birdSelect = new CustomSelect({
    elem: document.querySelector('select')
  });
}
  
